<template>
  <div 
    :style="jumbotronContainerStyles" 
    class="jumbotron-container">
    <div :style="jumbotronContentStyles" id="jumbotron">
      <h1 class="jumbo newfont text1">Composer</h1>
      <h1 class="jumbo newfont text2">Software</h1>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Jumbotron',
  props: {
    msg: String,
    title:{
      type:String,
      default:"Jumbotron"
    },
    jumbotronContainerStyles:{
      type:Object,
      default:function(){return {}}
    },
    jumbotronContentStyles:{
      type:Object,
      default:function(){return {}}
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jumbotron-container {
  box-sizing:border-box;
  display: flex;
  min-height:100px;
  padding:1em;
  width:100vw;
}
.border {
  border: 1px dashed navy;
}
#jumbotron {
  width:100%;
  background-color:black;
  border:5px solid black;
  border-radius:15px;
}
.text1 {
  margin:0;
  color:white;
}
.text2 {
  color:black;
  background-color:white;
  margin:0;
  border-radius:10px;
}
.flex1 {
  display:flex;
  flex-direction:column;
}
.big {
  font-size:6em;
}
.huge {
  font-size:9em;
}
.jumbo {
  font-size:12em;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}

@media only screen and (max-width: 900px) {
  .jumbo {
    font-size:7em;
  }
}
@media only screen and (max-width: 600px) {
  .jumbo {
    font-size:4em;
  }
  .jumbotron-container {
    min-height:0px;
  }
}
</style>
